"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpScheduleEditDialog = void 0;
const OpScheduleModel_1 = __importDefault(require("@opsbase/lib-data-model/models/OpScheduleModel"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useOpScheduleUpdate_1 = __importDefault(require("@opsbase/react-gql-hooks/opschedule/useOpScheduleUpdate"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const validateOpSchedule_1 = __importDefault(require("../helpers/validateOpSchedule"));
const OpScheduleEditor_1 = __importDefault(require("../OpScheduleEditor"));
function OpScheduleEditDialog(props) {
    const { opSchedule, onClose, onChange } = props;
    const [localOpSchedule, setLocalOpSchedule] = (0, react_1.useState)(new OpScheduleModel_1.default(opSchedule));
    const updateOpSchedule = (0, useOpScheduleUpdate_1.default)();
    const invalid = !(0, validateOpSchedule_1.default)(localOpSchedule);
    const [busy, setBusy] = (0, react_1.useState)(false);
    const handleClickCancel = (0, react_1.useCallback)(() => onClose === null || onClose === void 0 ? void 0 : onClose(), [onClose]);
    const handleClickSave = (0, react_1.useCallback)(() => {
        const l = localOpSchedule;
        setBusy(true);
        updateOpSchedule({
            id: l.id,
            patch: {
                allPlacesPermitted: l.allPlacesPermitted,
                placesSelectedByTag: l.placesSelectedByTag,
                placesSelectedByParent: l.placesSelectedByParent,
                places: (l.places || []).map(({ id }) => ({ id })),
                placeTags: l.placeTags || [],
                dueDate: l.dueDate,
                untilDate: l.untilDate,
                whenCanView: l.whenCanView,
                whenCanStart: l.whenCanStart,
                whenIsMissed: l.whenIsMissed,
                repetitionType: l.repetitionType,
                customRepetition: l.customRepetition,
            },
        })
            .catch(doNothing_1.default)
            .finally(() => {
            setBusy(false);
            onChange === null || onChange === void 0 ? void 0 : onChange();
            onClose === null || onClose === void 0 ? void 0 : onClose();
        });
    }, [localOpSchedule, onClose, onChange, updateOpSchedule]);
    return (react_1.default.createElement(Dialog_1.default, Object.assign({}, props, { closable: false, padded: false, title: lib_i18n_1.default.t('edit-schedule'), size: DialogSize_1.default.X1000_Y500, buttonsLeft: react_1.default.createElement(Button_1.default, { label: lib_i18n_1.default.t('cancel'), disabled: busy, color: lib_palette_1.default.Grey, onClick: handleClickCancel }), buttonsRight: react_1.default.createElement(Button_1.default, { disabled: invalid || busy, label: lib_i18n_1.default.t('save'), color: lib_palette_1.default.positive, onClick: handleClickSave }) }), !!localOpSchedule && (react_1.default.createElement(OpScheduleEditor_1.default, { opSchedule: localOpSchedule, onChange: setLocalOpSchedule }))));
}
exports.OpScheduleEditDialog = OpScheduleEditDialog;
exports.default = OpScheduleEditDialog;
